import { Modal, ModalFooter, ModalBody } from "reactstrap";
import { useState } from "react";
import * as promotionTypes from "../utils/constants/promotionTypes.js";
import { CONFIRMATION } from "../utils/constants/index.js";
import PendingModalContent from "./ModalContents/PendingModalContent";
import UpcomingModalContent from "./ModalContents/UpcomingModalContent.jsx";
import ActiveModalContent from "./ModalContents/ActiveModalContent.jsx";
import ConfirmationModalContent from "./ModalContents/ConfirmationModalContent.jsx";
import "../styles/UniversalModal.css";

const returnHome = () => {
  window.location.href = "/home";
};

function getModalTrackId(contentType, action) {
  switch (contentType) {
    case promotionTypes.ActivePromotion:
      return `${action}-promotion-details`;
    case promotionTypes.UpcomingPromotion:
      return `${action}-upcoming-promotion`;
    case promotionTypes.PendingPromotion:
      return `${action}-pending-promotion`;
    case CONFIRMATION:
      return `${action}-cancel`;
    default:
      return undefined;
  }
}

function renderModalBody({
  contentType,
  incentive,
  promotionDescription,
  daysRemaining,
  setShow,
}) {
  switch (contentType) {
    case promotionTypes.PendingPromotion:
      return (
        <PendingModalContent
          promotionDescription={promotionDescription}
          daysRemaining={daysRemaining}
        />
      );
    case promotionTypes.UpcomingPromotion:
      return (
        <UpcomingModalContent
          promotionDescription={promotionDescription}
          daysRemaining={daysRemaining}
        />
      );
    case promotionTypes.ActivePromotion:
      return <ActiveModalContent incentive={incentive} />;
    case CONFIRMATION:
      return <ConfirmationModalContent setShow={setShow} />;
    default:
      return null;
  }
}

// Universal Modal Created to have a standard look between informational modals.
// The contents of the modal should be created in their own component within the ModalContents Folder
// Make sure to pass in SetShow, header, and contentType at a minimum.
const UniversalModal = ({
  setShow,
  header,
  contentType,
  incentive,
  promotionDescription,
  daysRemaining,
}) => {
  const [modal, setModal] = useState(true);
  const isCancelConfirmation = contentType === CONFIRMATION;

  const toggle = () => {
    setModal(!modal);
    setShow(false);
  };

  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      fade={false}
      contentClassName="universal-modal-style"
    >
      <div>
        <h2 className="universal-modal-header">{header}</h2>
        <button
          type="button"
          className="icon-close universal-modal-close"
          onClick={toggle}
          aria-label="Close"
          data-trackid={getModalTrackId(contentType, "dismiss")}
        />
      </div>
      <ModalBody className="universal-modal-body">
        {renderModalBody({
          contentType,
          incentive,
          promotionDescription,
          daysRemaining,
          setShow,
        })}
      </ModalBody>
      <ModalFooter>
        {isCancelConfirmation && (
          <button
            className="btn btn-primary"
            onClick={() => {
              toggle();
              returnHome();
            }}
            data-testid="confirmationYes"
            data-trackid="confirm-cancel"
          >
            Yes
          </button>
        )}
        <button
          className="btn btn-primary"
          onClick={toggle}
          data-trackid={getModalTrackId(contentType, "close")}
        >
          Close
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default UniversalModal;
